import { SYNC_LIMIT_50 } from '@/utilities/constants';

import { InspectionResultDocument } from '../InspectionResults/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SignatureDocument } from '../Signature/rxdbSignatureDefinition';
import {
  CuttingPermitSupervisorCommentDocument,
  cuttingPermitSupervisorCommentPullQueryBuilder,
  cuttingPermitSupervisorCommentPushModifier,
  cuttingPermitSupervisorCommentPushQueryBuilder,
} from './queryBuilder';

export function cuttingPermitSupervisorCommentFamilyMember(
  configBuilder: ConfigBuilder,
  inspectionResults: FamilyMember<InspectionResultDocument>,
  signatures: FamilyMember<SignatureDocument>,
): FamilyMember<CuttingPermitSupervisorCommentDocument> {
  const syncConfig = configBuilder<CuttingPermitSupervisorCommentDocument>(
    RxdbCollectionNameV2.CUTTING_PERMIT_SUPERVISOR_COMMENT,
  );
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, cuttingPermitSupervisorCommentPullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_50;

  const pushConfig = push(syncConfig, cuttingPermitSupervisorCommentPushQueryBuilder);
  pushConfig.modifier = cuttingPermitSupervisorCommentPushModifier;

  const replicationState = replicate(syncConfig);
  // Legacy sets the syncInterval to LiveInterval.SECONDS_60 and retryTime to 7500
  return create(RxdbCollectionNameV2.CUTTING_PERMIT_SUPERVISOR_COMMENT, replicationState, [
    inspectionResults,
    signatures,
  ]);
}
